export const ST = `%c
github.com/talipakcelik
twitter.com/talipakcelik
talipakcelik@gmail.com
https://youtu.be/CnnGYaqjW-A`
